import React, { createContext, useContext, useState } from 'react';

namespace LinkPreview {
    export interface OGData {
        ogTitle?: string;
        ogDescription?: string;
        ogImage?: Array<{ url: string }>;
        error?: boolean;
    }

    export interface Context {
        cache: Record<string, OGData>;
        loadingUrls: Set<string>;
        setCache: (url: string, data: OGData) => void;
        setLoading: (url: string, isLoading: boolean) => void;
    }
}

const LinkPreviewContext = createContext<LinkPreview.Context>({
    cache: {},
    loadingUrls: new Set(),
    setCache: () => {},
    setLoading: () => {}
});

export const LinkPreviewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [cache, setCache] = useState<Record<string, LinkPreview.OGData>>({});
    const [loadingUrls, setLoadingUrls] = useState(new Set<string>());

    const value: LinkPreview.Context = {
        cache,
        loadingUrls,
        setCache: (url, data) => setCache((prev) => ({ ...prev, [url]: data })),
        setLoading: (url, isLoading) =>
            setLoadingUrls((prev) => {
                const next = new Set(prev);
                isLoading ? next.add(url) : next.delete(url);
                return next;
            })
    };

    return <LinkPreviewContext.Provider value={value}>{children}</LinkPreviewContext.Provider>;
};

export const useLinkPreviewCache = () => useContext(LinkPreviewContext);
